import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import CollectionKanbanBoard from "@/components/collections/kanban/collection-kanban-board";

// `passthrough`: los filtros por valor de la tabla (`value:<campo>`) viajan
// en la URL y el kanban los aplica igual.
const kanbanSearchSchema = z.object({ search: z.string().optional() }).passthrough();

export const Route = createFileRoute("/_authenticated/collections/$collectionId/kanban")({
  validateSearch: kanbanSearchSchema,
  component: CollectionKanbanPage,
});

function CollectionKanbanPage() {
  const { collectionId } = Route.useParams();
  const searchParams = Route.useSearch();
  return <CollectionKanbanBoard key={collectionId} collectionId={collectionId} searchParams={searchParams} />;
}
